// extracted by mini-css-extract-plugin
export default {"container":"AppErrorFallback_container__IbP5q","title":"AppErrorFallback_title__qY4QU","subtitle":"AppErrorFallback_subtitle__TfqCk","button":"AppErrorFallback_button__+1md9"};